import {SET_SEARCH,SET_SEARCHH} from '../data/search_data';

import SearchModel from '../model/search';
const initalState = {
  videos:[],
  searchUsers:[],
  images:[],
  tages:[],
  communities:[]
}
export default (state=initalState,actions) =>{
  switch (actions.type) {

    case SET_SEARCH:
    return{
      ...state,searchUsers:actions.data,
images:actions.images,
videos:actions.videos,
tages:actions.tages,
communities:actions.communities || []
    }
    case SET_SEARCHH:
    return{
      ...state,searchUsers:state.searchUsers.concat(actions.data),
images:state.images.concat(actions.images),
videos:state.videos.concat(actions.videos),
tages:state.tages.concat(actions.tages),
communities:state.communities.concat(actions.communities || [])
    }


  }
  return state;
}
